import { linea, lineaSepolia } from 'thirdweb/chains'

import { codex, codexTestnet } from './chain'

/**
 * Map of supported chains to USDC contract addresses.
 */
export const CHAIN_IDS_TO_USDC_ADDRESSES = {
  [codexTestnet.id]: '0x6d7f141b6819C2c9CC2f818e6ad549E7Ca090F8f',

  [codex.id]: '0xd996633a415985DBd7D6D12f4A4343E31f5037cf',

  [lineaSepolia.id]: '0xfece4462d57bd51a6a552365a011b95f0e16d9b7',

  [linea.id]: '0x176211869ca2b568f2a7d4ee941e073a821ee1ff',
}

/**
 * Map of supported chains to Token Messenger contract addresses.
 */
export const CHAIN_IDS_TO_TOKEN_MESSENGER_ADDRESSES = {
  [codexTestnet.id]: '0x8FE6B999Dc680CcFDD5Bf7EB0974218be2542DAA',

  [codex.id]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d',

  [lineaSepolia.id]: '0x8FE6B999Dc680CcFDD5Bf7EB0974218be2542DAA',

  [linea.id]: '0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d',
}

/**
 * Map of supported chains to Message Transmitter contract addresses.
 */
export const CHAIN_IDS_TO_MESSAGE_TRANSMITTER_ADDRESSES = {
  [codexTestnet.id]: '0xE737e5cEBEEBa77EFE34D4aa090756590b1CE275',

  [codex.id]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64',

  [lineaSepolia.id]: '0xE737e5cEBEEBa77EFE34D4aa090756590b1CE275',

  [linea.id]: '0x81D40F21F12A8F0E3252Bccb954D722d4c464B64',
}
